import { render, staticRenderFns } from "./DocumentTemplateDigitalNotePreview.vue?vue&type=template&id=b0f01cfe&scoped=true&lang=pug&"
import script from "./DocumentTemplateDigitalNotePreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateDigitalNotePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f01cfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
